import { observer } from 'mobx-react-lite';
import React from 'react';
import { TabPanel } from 'react-tabs';
import { colors } from '../../../../../../../../colorVars';
import { modifySoftOrder } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/modifySoftOrders';
import { updatePlugins } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/updatePlugins';
import { useWebsocketStore } from '../../../../../../../../stores/websocketStore/websocketProvider';
import { EditableTableField } from '../../../../../../../atomic/inputs/editableTableField/EditableTableField';
import { Body3 } from '../../../../../../../atomic/text/Text';
import { IndividualPanelHeader } from '../IndividualPanelHeader';
import style from '../IndividualTacticStyle.module.css';

export const GreenToRedCandlesTacticPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, addTab, ...rest }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId];
    const tacticId = tradePlan.exitTactics['GREEN_TO_RED_CANDLES']?.tacticId ?? null;
    const inPosition = tradePlan?.inPosition ?? null;
    const softOrder = tradePlanStore.softOrdersById[tacticId] ?? null;
    const state = softOrder?.value.tacticValue.state ?? null;

    const updateSoftOrder = (type, value) => {
      modifySoftOrder({ softOrder, type, value });
    };

    const updateTactic = (field, newValue) => {
      updatePlugins(
        'tactic',
        { [field]: newValue },
        'GREEN_TO_RED_CANDLES',
        tradePlanId,
        null
      );
    };
    if (!tradePlan?.exitTactics['GREEN_TO_RED_CANDLES']) return null;
    return (
      <TabPanel {...rest}>
        <div className={style.tableContainer}>
          <table className={style.table}>
            <IndividualPanelHeader />
            {inPosition && softOrder ? (
              <tbody>
                <tr>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      Candle Duration
                    </Body3>
                  </td>
                  <td className={style.inputTd}>
                    <EditableTableField
                      inputType="number"
                      bodySize={3}
                      initialValue={softOrder.value.tacticValue.candleDuration}
                      updateValue={(newValue) =>
                        updateSoftOrder('candleDuration', newValue)
                      }
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                    />
                  </td>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      Time Unit(read-only)
                    </Body3>
                  </td>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      {softOrder?.value.tacticValue.timeUnit}
                    </Body3>
                  </td>
                </tr>
                <tr>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      {state === 'RIGHT_DIRECTION'
                        ? 'In Right Direction %'
                        : 'Retrace %'}
                    </Body3>
                  </td>
                  <td className={style.inputTd}>
                    <EditableTableField
                      inputType="number"
                      bodySize={3}
                      initialValue={
                        state === 'RIGHT_DIRECTION'
                          ? Number(
                            softOrder.value.tacticValue.inRightDirectionPct
                          ) * 100
                          : Number(softOrder.value.tacticValue.retracePct) * 100
                      }
                      updateValue={(newValue) =>
                        updateSoftOrder(
                          state === 'RIGHT_DIRECTION'
                            ? 'inRightDirectionPct'
                            : 'retracePct',
                          Number(newValue) / 100
                        )
                      }
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                    />
                    <Body3
                      fontWeight={700}
                      color={colors.lightGrey}
                      margin="3px 3px 0 0"
                    >
                      %
                    </Body3>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            ) : (
              <tbody>
                <tr>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      Candle Duration
                    </Body3>
                  </td>
                  <td className={style.inputTd}>
                    <EditableTableField
                      inputType="number"
                      bodySize={3}
                      initialValue={
                        tradePlan.exitTactics['GREEN_TO_RED_CANDLES']
                          .candleDuration
                      }
                      updateValue={(newValue) =>
                        updateTactic('candleDuration', newValue)
                      }
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                    />
                  </td>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      Time Unit(read-only)
                    </Body3>
                  </td>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      {tradePlan.exitTactics['GREEN_TO_RED_CANDLES'].timeUnit}
                    </Body3>
                  </td>
                </tr>
                <tr>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      In Right Direction %
                    </Body3>
                  </td>
                  <td className={style.inputTd}>
                    <EditableTableField
                      inputType="number"
                      bodySize={3}
                      initialValue={
                        Number(
                          tradePlan.exitTactics['GREEN_TO_RED_CANDLES']
                            .inRightDirectionPct
                        ) * 100
                      }
                      updateValue={(newValue) =>
                        updateTactic(
                          'inRightDirectionPct',
                          Number(newValue) / 100
                        )
                      }
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                    />
                    <Body3
                      fontWeight={700}
                      color={colors.lightGrey}
                      margin="3px 3px 0 0"
                    >
                      %
                    </Body3>
                  </td>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      Retrace %
                    </Body3>
                  </td>
                  <td className={style.inputTd}>
                    <EditableTableField
                      inputType="number"
                      bodySize={3}
                      initialValue={
                        Number(
                          tradePlan.exitTactics['GREEN_TO_RED_CANDLES']
                            .retracePct
                        ) * 100
                      }
                      updateValue={(newValue) =>
                        updateTactic('retracePct', Number(newValue) / 100)
                      }
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                    />
                    <Body3
                      fontWeight={700}
                      color={colors.lightGrey}
                      margin="3px 3px 0 0"
                    >
                      %
                    </Body3>
                  </td>
                </tr>
                <tr>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      Min. Candle Height
                    </Body3>
                  </td>
                  <td className={style.inputTd}>
                    <Body3
                      fontWeight={700}
                      color={colors.lightGrey}
                      margin="3px 3px 0 0"
                    >
                      $
                    </Body3>
                    <EditableTableField
                      inputType="number"
                      bodySize={3}
                      initialValue={
                        tradePlan.exitTactics['GREEN_TO_RED_CANDLES']
                          .minCandleHeight
                      }
                      updateValue={(newValue) =>
                        updateTactic('minCandleHeight', newValue)
                      }
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                    />
                  </td>
                </tr>
              </tbody>
            )}
          </table>
        </div>
      </TabPanel>
    );
  }
);

GreenToRedCandlesTacticPanel.tabsRole = 'TabPanel';
